module.exports = __webpack_public_path__ + "media/images/pdf-down-arrow-c34affe8b43c4ce8cf51db3d9ea2c8e0.png";